import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import {
  ADD_ORGANIZATION_ADMIN,
  CHANGE_DEFAULT_SPACE,
  FETCH_ORGANIZATION_ADMINS,
  REMOVE_ORGANIZATION_ADMIN,
  UPDATE_ORGANIZATION
} from './actionTypes'

export const addOrganizationAdmin = (userId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/users/${userId}/roles`,
        ADD_ORGANIZATION_ADMIN,
        { method: 'POST', body: {} },
        { args: { organizationId: ':organizationId', userId: ':userId' } }
      )
    )
  }
}

export const fetchOrganizationAdmins = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/users/roles`,
        FETCH_ORGANIZATION_ADMINS,
        {},
        { args: { organizationId: ':organizationId' } }
      )
    )
  }
}

export const removeOrganizationAdmin = (userId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/users/${userId}/roles`,
        REMOVE_ORGANIZATION_ADMIN,
        { method: 'DELETE', body: { userId } },
        { args: { organizationId: ':organizationId' } }
      )
    )
  }
}

export const changeDefaultSpace = (spaceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/defaultspace`,
        CHANGE_DEFAULT_SPACE,
        { method: 'PUT', body: { id: spaceId } },
        { args: { organizationId: ':organizationId', spaceId: spaceId } }
      )
    )
  }
}

export const updateOrganization = (organization: object): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId`,
        UPDATE_ORGANIZATION,
        { method: 'PUT', body: organization },
        { args: { organizationId: ':organizationId' } }
      )
    )
  }
}
